import { select } from 'redux-saga/effects';
import isEmptyHTMLMessage from '../../../utils/isEmptyHTMLMessage';

export function* getServerTime() {
  const generalState = yield select(state => state.general);
  const { serverTime, serverTimeUpdatedAt } = generalState;
  const now = Math.round(Date.now() / 1000);
  const diff = now - serverTimeUpdatedAt;
  return serverTime + diff;
}

export function getQueryWithPhones(q = '') {
  const regex =
    /(\+?)(7|8)(\D{0,2})(\d{3})(\D{0,2}?)(\d{3})(\D{0,1})(\d{2})(\D{0,1})(\d{2})/g;

  return q.replaceAll(regex, (p = '') => p.replaceAll(/\D/g, '')) || '';
}

export function getSafeMessageBody(text) {
  if (!text) return text;

  const container = document.createElement('div');
  container.innerHTML = text;

  const blockedTags = new Set([
    'SCRIPT',
    'IFRAME',
    'OBJECT',
    'EMBED',
    'APPLET',
  ]);

  const hasUnsafeProtocol = value =>
    /^(\s*javascript:|\s*vbscript:)/i.test(value || '');
  const isUnsafeStyle = value =>
    /(expression\s*\(|url\(\s*javascript:)/i.test(value || '');

  const sanitizeUrlAttr = (el, attrName) => {
    const val = el.getAttribute(attrName);
    if (!val) return;

    if (hasUnsafeProtocol(val)) {
      el.removeAttribute(attrName);
      return;
    }

    if (/^\s*data:/i.test(val)) {
      if (el.tagName !== 'IMG' || !/^\s*data:image\//i.test(val)) {
        el.removeAttribute(attrName);
      }
    }
  };

  const sanitizeElement = el => {
    if (blockedTags.has(el.tagName)) {
      el.remove();
      return;
    }

    Array.from(el.attributes).forEach(attr => {
      const name = attr.name;
      const value = attr.value;

      if (/^on/i.test(name)) {
        el.removeAttribute(name);
        return;
      }

      if (/(^|:)(href|src|xlink:href|formaction|poster)$/i.test(name)) {
        sanitizeUrlAttr(el, name);
        return;
      }

      if (name.toLowerCase() === 'srcdoc') {
        el.removeAttribute(name);
        return;
      }

      if (name.toLowerCase() === 'style' && isUnsafeStyle(value)) {
        el.removeAttribute(name);
      }
    });

    Array.from(el.children).forEach(child => sanitizeElement(child));
  };

  Array.from(container.children).forEach(child => sanitizeElement(child));

  const result = container.innerHTML;
  const regex = /min-height:[\\n|\\t|\s]*100%\s*!important;*/gi;
  return result.replaceAll(regex, '');
}

// функция для замены тегов <br> между другими тегами на div, а в тексте на \n
export function replaceBrBetweenNodes(node) {
  if (node.nodeType === Node.ELEMENT_NODE) {
    const children = node.childNodes;

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < children.length; i++) {
      const child = children[i];

      if (child.nodeName === 'BR') {
        const { previousSibling, nextSibling } = child;

        // Проверяем, есть ли соседи #text перед или после тега <br>
        const hasTextBefore =
          previousSibling &&
          previousSibling.nodeType === Node.TEXT_NODE &&
          previousSibling.textContent.trim().length > 0;
        const hasTextAfter =
          nextSibling &&
          nextSibling.nodeType === Node.TEXT_NODE &&
          nextSibling.textContent.trim().length > 0;

        if (!hasTextBefore && !hasTextAfter) {
          const divElement = document.createElement('div');
          node.replaceChild(divElement, child);
          // eslint-disable-next-line no-plusplus
          i--; // Уменьшаем счетчик, так как удалили элемент
        }
      } else {
        replaceBrBetweenNodes(child); // Рекурсивно обходим потомков
      }
    }
  }
}

function wrapTextInP(node) {
  if (node.nodeType === Node.ELEMENT_NODE) {
    const children = [...node.childNodes]; // Создание копии массива childNodes

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < children.length; i++) {
      const child = children[i];

      if (child.nodeType === 3 && child.nodeValue.trim() !== '') {
        const pElement = document.createElement('p');
        pElement.textContent = child.nodeValue.trim();
        node.replaceChild(pElement, child);
      } else if (child.nodeName === 'BR') {
        node.removeChild(child);
      } else {
        wrapTextInP(child);
      }
    }
  }
}

export function replaceBrInStr(text) {
  const lines = text.split(/\n|<br\s*\/?>/i);
  if (lines.length <= 1) return text;

  const wrappedLines = lines.map(line => {
    return `<div>${line?.trim()}</div>`;
  });
  return wrappedLines.join('');
}

export function addEmptySpacesToStr(str) {
  return str
    ? str.replaceAll(
        /<div(?:\s+class=["']slate-div["'])?><\/div>/g,
        '<div>&nbsp; </div>'
      )
    : '';
}

export function normalizeHTMLString(str) {
  if (isEmptyHTMLMessage(str)) return str;
  return addEmptySpacesToStr(replaceBrInStr(str));
}

export function processText(str) {
  const div = document.createElement('div');
  div.innerHTML = str;

  replaceBrBetweenNodes(div);
  wrapTextInP(div);

  return div.innerHTML;
}

export function setAttachmentsInFormData(formData, attachments) {
  Array.from(attachments).forEach(file => {
    if (file instanceof File) {
      formData.append('attachments[]', file);
    } else if (file?.id) {
      formData.append('order_attachments[]', file.id);
    } else {
      formData.append('custom_attachments[]', JSON.stringify(file));
    }
  });
}

export const customMerge = (value, srcValue) => {
  if (Array.isArray(srcValue)) {
    return srcValue;
  }
};